(() => {
  'use strict';

  document.querySelectorAll('[data-section-id]').forEach((root) => {
    if (!root.classList.contains('main-product-gear')) return;
    initGearPdp(root);
  });

  function initGearPdp(root) {
    const productId = root.dataset.productId;

    /* ---- thumbnails: swap the main image, no re-fetch ---- */
    const mainImage = root.querySelector('[data-gear-main-image]');
    const thumbs = root.querySelectorAll('[data-gear-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        const img = mainImage ? mainImage.querySelector('img') : null;
        if (img && thumb.dataset.fullSrc) img.src = thumb.dataset.fullSrc;
      });
    });

    /* ---- quantity stepper ---- */
    const qtyInput = root.querySelector('[data-gear-qty-input]');
    const qtyDecrease = root.querySelector('[data-gear-qty-decrease]');
    const qtyIncrease = root.querySelector('[data-gear-qty-increase]');
    if (qtyInput && qtyDecrease && qtyIncrease) {
      qtyDecrease.addEventListener('click', () => {
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = next;
      });
      qtyIncrease.addEventListener('click', () => {
        const next = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = next;
      });
    }

    /* ---- add to cart: normal accumulate-in-cart flow, same shape as
       sections/product-custom.liquid - NOT product-shift's
       clear-then-checkout bypass. Dispatches cart:updated, which
       cart-drawer.js already listens for on every Gear page. ---- */
    const form = root.querySelector('.main-product-gear__form');
    const addButton = root.querySelector('[data-gear-add]');
    const addLabel = root.querySelector('[data-gear-add-label]');
    if (form && addButton) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (addButton.disabled) return;
        addButton.disabled = true;
        const originalLabel = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = addLabel.dataset.loadingText || originalLabel;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then((res) => (res.ok ? res.json() : res.json().then((d) => { throw new Error(d.description || 'Add to cart failed'); })))
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch((err) => console.error(err))
          .finally(() => {
            addButton.disabled = false;
            if (addLabel) addLabel.textContent = originalLabel;
          });
      });
    }

    /* ---- tee variant matrix: swatches + sizes ---- */
    const teeControls = root.querySelector('[data-gear-tee-controls]');
    if (teeControls) {
      let variants = [];
      let variantPrices = {};
      try {
        variants = JSON.parse(document.getElementById('GearVariants-' + productId).textContent);
      } catch (e) {
        variants = [];
      }
      try {
        variantPrices = JSON.parse(document.getElementById('GearVariantPrices-' + productId).textContent);
      } catch (e) {
        variantPrices = {};
      }
      const colorIndex = parseInt(teeControls.dataset.colorIndex, 10) - 1;
      const sizeIndex = parseInt(teeControls.dataset.sizeIndex, 10) - 1;
      const variantIdInput = root.querySelector('[data-gear-variant-id]');
      const priceEl = root.querySelector('[data-gear-price]');
      const soldOutNote = root.querySelector('[data-gear-sold-out-note]');

      const state = {
        color: teeControls.querySelector('.gear-tee-controls__swatch.is-selected')?.dataset.value,
        size: teeControls.querySelector('.gear-tee-controls__size.is-selected')?.dataset.value,
      };

      const findVariant = (color, size) => variants.find((v) => v.options[colorIndex] === color && v.options[sizeIndex] === size);

      const render = () => {
        const variant = findVariant(state.color, state.size);
        teeControls.querySelectorAll('[data-gear-swatch]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === state.color);
          el.setAttribute('aria-pressed', el.dataset.value === state.color ? 'true' : 'false');
        });
        teeControls.querySelectorAll('[data-gear-size]').forEach((el) => {
          const v = findVariant(state.color, el.dataset.value);
          el.classList.toggle('is-selected', el.dataset.value === state.size);
          el.classList.toggle('is-sold-out', !!v && !v.available);
          el.disabled = !v;
        });
        if (variant) {
          if (variantIdInput) variantIdInput.value = variant.id;
          if (addButton) addButton.disabled = !variant.available;
          if (addLabel) {
            const formattedPrice = variantPrices[variant.id] || '';
            addLabel.textContent = variant.available
              ? (addLabel.dataset.addTemplate || addLabel.textContent).replace('{price}', formattedPrice)
              : (addLabel.dataset.soldOutText || addLabel.textContent);
          }
          if (soldOutNote) {
            if (!variant.available) {
              soldOutNote.hidden = false;
              soldOutNote.textContent = (soldOutNote.dataset.template || '').replace('{size}', state.size);
            } else {
              soldOutNote.hidden = true;
            }
          }
        }
      };

      teeControls.querySelectorAll('[data-gear-swatch]').forEach((el) => {
        el.addEventListener('click', () => {
          state.color = el.dataset.value;
          render();
        });
      });
      teeControls.querySelectorAll('[data-gear-size]').forEach((el) => {
        el.addEventListener('click', () => {
          if (el.disabled) return;
          state.size = el.dataset.value;
          render();
        });
      });
    }

    /* ---- sticker pack rows: cosmetic selection only - "one" is the
       sole real, enabled option; disabled rows can't be clicked anyway,
       this just handles the enabled one for visual feedback. ---- */
    root.querySelectorAll('[data-gear-pack]').forEach((el) => {
      el.addEventListener('click', () => {
        if (el.disabled) return;
        root.querySelectorAll('[data-gear-pack]').forEach((p) => {
          p.classList.toggle('is-selected', p === el);
          p.setAttribute('aria-pressed', p === el ? 'true' : 'false');
        });
      });
    });

    /* ---- size guide drawer: same mechanics as sections/cart-drawer.liquid
       (scrim+panel siblings, manual focus trap, Escape, slide-in) reimplemented
       for this static, non-refetched content. ---- */
    const drawer = document.querySelector('[data-gear-size-guide]');
    const openTrigger = root.querySelector('[data-gear-size-guide-open]');
    if (drawer && openTrigger) {
      const panel = drawer.querySelector('.gear-size-guide__panel');
      const scrim = drawer.querySelector('[data-gear-size-guide-scrim]');
      const closeButton = drawer.querySelector('[data-gear-size-guide-close]');
      let lastFocused = null;

      /* BUGS-2026-09-10-b #4: keeps the closed, off-canvas panel's own
         links out of the Tab order (visibility:hidden alone doesn't). */
      panel.inert = true;

      const getFocusable = () =>
        Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(
          (el) => el.offsetParent !== null
        );

      const onKeydown = (event) => {
        if (event.key === 'Escape') {
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      function open() {
        lastFocused = document.activeElement;
        panel.inert = false;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.addEventListener('keydown', onKeydown);
        if (closeButton) closeButton.focus();
      }

      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        panel.inert = true;
        document.removeEventListener('keydown', onKeydown);
        if (lastFocused) lastFocused.focus();
      }

      openTrigger.addEventListener('click', open);
      if (closeButton) closeButton.addEventListener('click', close);
      if (scrim) scrim.addEventListener('click', close);
    }
  }
})();
